// ========= GLOBAL CONSTANTS ===========
// let mobile_menu;
let width = $(window).width();
let device_state = (width >= 992) ? 'desktop' : (width >= 576) ? 'tablet' : 'mobile';
// ========= GLOBAL CONSTANTS ===========

window.checkIfExists = ($item) => {
  const item = $($item).length;
  return (item > 0);
}

window.loadjs = (script_filename) => {
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', script_filename);
    script.setAttribute('id', 'script_id');

    script_id = document.getElementById('script_id');
    if(script_id){
        document.getElementsByTagName('head')[0].removeChild(script_id);
    }
    document.getElementsByTagName('head')[0].appendChild(script);
}


window.arraySearch = (arr,val) => {
    for (var i=0; i<arr.length; i++)
        if (arr[i] === val)
            return i;
    return false;
  }


window.checkBackToTop = ($item, $base) => {
  if (width < 768 && $(window).scrollTop() > 200) {
    $('.back-to-top').fadeIn('fast');
  } else {
    // If item exists
    if (checkIfExists($item)) {
      // And item (ex. Products box) height is more than base (ex. Filers box) then show Back to top Button
      if ($($item).innerHeight() > $($base).innerHeight()) {
        $('.back-to-top').fadeIn('fast');
      }
    }
  }

}

window.backToTop = ($item, $offset = 100, $time = 500) => {
  $('.back-to-top').click(function (e) {
    e.preventDefault()
    $('html, body').animate({
      scrollTop: $($item).offset().top - $offset
    }, $time);
  })
}

window.showModal = function($modal, $modalUrl) {
    $($modal).find('.modal-content').load($modalUrl);
}


window.hideOnSubmit = ($button, $holder = '', $hasErr = false) => {
  // Showing wait button on form submit

  // $button -- The submit button to be hidden
  // $holder -- In case there are 2 forms in a single page
  // $hasErr --  If there's an error, show back the submit button (true/false)

  if ($hasErr) {
    $(`${$holder} .btn-wait`).addClass('d-none');
    $($button).removeClass('d-none');
    return
  }
  $($button).addClass('d-none');
  $(`${$holder} .btn-wait`).removeClass('d-none');
}


window.formatNumber = (num) => {
  return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}


window.removeOpenedWindows = () => {
  // Closing all opened windows/boxes such as Cart, Search Form on mobile etc..
  // $('header .language').dropdown('hide');
  $('#filters').removeClass('opened-filter');
  $('.quick-cart-items').removeClass('cart-active');
  $('.overlay').fadeOut('fast');
  $('.overlay').css('z-index', '');
  $.sidr('close', 'sidr-main');
  $.sidr('close', 'sidr-right');
  $.sidr('close', 'sidr-filter');
  $('html, body').removeClass('overflow-hidden');
  if ($(window).width() < 992) {
    $('header .search-form').stop().slideUp('fast');
  } else {
    $('header .search-form').stop().slideDown('fast');
  }
  setTimeout(function () {
    $('.mm-slideout').css('z-index', '');
  }, 100)
}
